<template>
  <filter-template @submit="filter()">
    <v-row class="py-6">
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <span>Data da criação</span>
            <v-row class="pt-2">
              <v-col cols="6">
                <input-date
                  id="input:MinCreatedAt"
                  v-model="payload.MinCreatedAt"
                  label="Inicial"
                />
              </v-col>
              <v-col cols="6">
                <input-date
                  id="input:MaxCreatedAt"
                  v-model="payload.MaxCreatedAt"
                  label="Final"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span>Data da atualização</span>
            <v-row class="pt-2">
              <v-col cols="6">
                <input-date
                  id="input:MinUpdatedAt"
                  v-model="payload.MinUpdatedAt"
                  label="Inicial"
                />
              </v-col>
              <v-col cols="6">
                <input-date
                  id="input:MaxUpdatedAt"
                  v-model="payload.MaxUpdatedAt"
                  label="Final"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col cols="12">
            <input-select
              id="input:ReportStatus"
              v-model="payload.ReportStatus"
              label="Situação"
              :items="ReportStatus"
              clearable
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </filter-template>
</template>

<script>
import FilterMixin from '@/app/arch/components/crud/crud-mixins/FilterMixin';
import FilterTemplate from '@/app/arch/components/crud/components/FilterTemplate.vue';
import ReportStatus from '@/app/arch/enums/ReportStatus';

export default {
  name: 'ReportFilter',
  components: { FilterTemplate },
  mixins: [FilterMixin],
  data: () => ({
    payload: {
      MinCreatedAt: '',
      MaxCreatedAt: '',
      MinUpdatedAt: '',
      MaxUpdatedAt: '',
      ReportStatus: '',
    },
    ReportStatus,
  }),
};
</script>
